"use client"
import {observer} from "mobx-react";
import styled from "styled-components";
import {useContext, useEffect, useRef, useState} from "react";
import {LayoutContext} from "@/app/ClientRootHomepage";
import MainVisualBanner from "@/app/homepage/main/component/MainVisualBanner";
import NeedsWrap from "@/app/homepage/main/component/NeedsWrap";
import ResearchLabWrap from "@/app/homepage/main/component/ResearchLabWrap";
import NewsWrap from "@/app/homepage/main/component/NewsWrap";
import CareerWrap from "@/app/homepage/main/component/CareerWrap";
import {useStore} from "@/store";

const MainPage = observer(() => {
    const {navigationStore} = useStore();
    const { rootRef } = useContext(LayoutContext);
    const [currentIndex, setCurrentIndex] = useState(0);
    const sectionRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];
    useEffect(() => {
        navigationStore.setClearNavigation();
    }, []);
    // useEffect(() => {
    //     if (!rootRef?.current) return;
    //     rootRef.current.style.scrollSnapType = "y mandatory";
    //     return () => {
    //         if (!rootRef?.current) return;
    //         rootRef.current.style.scrollSnapType = "unset";
    //     };
    // }, [rootRef]);
    useEffect(() => {
        const sections = sectionRefs.map((ref) => ref.current);
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const idx = sections.indexOf(entry.target);
                        setCurrentIndex(idx);
                    }
                });
            },
            { threshold: 0.5 }
        );
        sections.forEach((sec) => sec && observer.observe(sec));
        return () => observer.disconnect();
    }, [rootRef]);
    return(
        <>
            <MainPageWrap>
                <div ref={sectionRefs[0]} className="snap">
                    <MainVisualBanner className={currentIndex >= 0 ? "active mainSnap" : "mainSnap"}/>
                </div>
                <div ref={sectionRefs[1]} className="snap">
                    <NeedsWrap className={currentIndex >= 1 ? "active" : ""}/>
                </div>
                <div ref={sectionRefs[2]} className="snap">
                    <ResearchLabWrap className={currentIndex >= 2 ? "active" : ""}/>
                </div>
                <div ref={sectionRefs[3]} className="snap">
                    <NewsWrap className={currentIndex >= 3 ? "active" : ""}/>
                </div>
                <div ref={sectionRefs[4]} className="snap">
                    <CareerWrap className={currentIndex >= 4 ? "active" : ""}/>
                </div>
            </MainPageWrap>
        </>

    )
});
const MainPageWrap = styled.div`
min-height: 100%;
    //.snap{
    //    height: calc(var(--vh) * 100);
    //    scroll-snap-align: start;
    //}
    //.mainSnap{
    //    padding-top: 0;
    //}

`

export default MainPage;